// extracted by mini-css-extract-plugin
export default {"scroll":"Scrollbar_scroll__OAMu9"};